import { toast } from "sonner";
import React from "react";
import { CalendarX, RefreshCw, Baby } from "lucide-react";

// Pop-up ROJO para cancelaciones
export function toastCancel(msg = "Cita cancelada") {
  toast.custom(
    () => (
      <div
        data-testid="toast-cancel"
        className="flex items-center gap-3 w-full rounded-xl px-4 py-3 shadow-lg text-white font-semibold"
        style={{ background: "#DC2626" }}
      >
        <CalendarX size={20} className="shrink-0" />
        <span className="text-sm">{msg}</span>
      </div>
    ),
    { duration: 4000 }
  );
}

// Pop-up ROSA para seguimiento prenatal (siguiente control)
export function toastPrenatal(msg = "Es momento de agendar tu siguiente control prenatal") {
  toast.custom(
    () => (
      <div
        data-testid="toast-prenatal"
        className="flex items-center gap-3 w-full rounded-xl px-4 py-3 shadow-lg font-semibold"
        style={{ background: "#FDE7F0", color: "#9D255E", border: "1px solid #F0A8C6" }}
      >
        <Baby size={20} className="shrink-0" style={{ color: "#DB2777" }} />
        <span className="text-sm">{msg}</span>
      </div>
    ),
    { duration: 6000 }
  );
}

// Pop-up NARANJA para reagendados
export function toastReschedule(msg = "Cita reagendada") {
  toast.custom(
    () => (
      <div
        data-testid="toast-reschedule"
        className="flex items-center gap-3 w-full rounded-xl px-4 py-3 shadow-lg text-white font-semibold"
        style={{ background: "#EA580C" }}
      >
        <RefreshCw size={20} className="shrink-0" />
        <span className="text-sm">{msg}</span>
      </div>
    ),
    { duration: 4000 }
  );
}

